
import { ConfigurationParameters, Configuration, ParticipantApi, ParticipantsDTO } from "external-api/license-api";
import Cookies from "js-cookie";
import { trackPromise } from "react-promise-tracker";
import { CookieNames } from "utils/constants";
import { getToken } from "utils/cookieHelper";

import http from "./axiosService";
const apiUrl = `${process.env.REACT_APP_LICENSE_API_URL}`;

function getApi() {
    const token = getToken();
    const configParams: ConfigurationParameters = {
        basePath: apiUrl,
        baseOptions: {
            headers:
            {
                Authorization: `Bearer ${token}`
            }
        }
    };
    const axios = http.axios;
    const configuration = new Configuration(configParams);
    return new ParticipantApi(configuration, apiUrl, axios);
}

export default class ParticipantService {
    participantApi: ParticipantApi
    constructor() {
        this.participantApi = getApi();
    }

    updateGroupParticipants = async (groupId: string, participants: string[]) => {
        const payload: ParticipantsDTO = {
            groupId: groupId,
            participants: participants
        };
        const resp = await trackPromise(this.participantApi.participantUpdateParticipants(payload));
        return resp.data;
    }

}